import React, { Component } from 'react';

class OrgNameAlreadyExistsErrorModal extends Component {
	// useless constructor warning
	// constructor(props) {
	// 	super(props);
	// }

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.showOrgNameAlreadyExistsErrorModal !== this.props.showOrgNameAlreadyExistsErrorModal){
			if(this.props.showOrgNameAlreadyExistsErrorModal) {
				this.orgNameAlreadyExistsModalOpen.click();
				this.props.hideOrgNameAlreadyExistsErrorModal();
			}
		}
	}

	render () {

		return (
		  <div>
          <input type="hidden" ref={elem => this.orgNameAlreadyExistsModalOpen = elem} id="OrgNameAlreadyExistsModalOpen" data-bs-toggle="modal" data-bs-target="#OrgNameAlreadyExistsModal"/>
  			<div className="modal fade" id="OrgNameAlreadyExistsModal" tabIndex="-1" role="dialog" aria-labelledby="OrgNameAlreadyExistsModalLabel" aria-hidden="true">
               <div className="modal-dialog" role="document">
                 <div className="modal-content">
                   <div className="modal-header">
                   FirstNet Developer Program
                   </div>
                   <div className="modal-body">
                    An Organization with this name already exists. If you do not want to join the 
					existing Organization, please change the name.
                   </div>
                   <div className="modal-footer">
                   	<button className='button secondary light-bg' data-bs-dismiss="modal" name="OK">
           				OK
           			</button>
                   </div>
                 </div>
               </div>
             </div>
           </div>
		)
	}
}

export default OrgNameAlreadyExistsErrorModal;



// WEBPACK FOOTER //
// ./src/manageMyAccount/modals/OrgNameAlreadyExistsErrorModal.js